import { useState } from 'react';
import axios from 'axios';
import '../css/Auth.css'; // We'll create this CSS file next

export default function PremiumLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMsg, setForgotMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMsg('');
    
    try {
      const res = await axios.post('/api/login.php', { email, password });
      if (res.data.success) {
        sessionStorage.setItem("user", JSON.stringify(res.data.user));
        window.location.href = "/dashboard";
      } else {
        setMsg(res.data.message || "Invalid credentials");
      }
    } catch (err) {
      setMsg(err.response?.data?.message || "Server error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!forgotEmail) {
      setForgotMsg("Please enter your email");
      return;
    }
    
    try {
      const res = await axios.post('/api/forgot-password.php', { email: forgotEmail });
      setForgotMsg(res.data.message || "Reset instructions sent to your email");
    } catch (err) {
      setForgotMsg(err.response?.data?.message || "Error sending reset email");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Welcome Back</h2>
          <p>Please enter your credentials to login</p>
        </div>
        
        <form onSubmit={login} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="spinner"></span> Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
          
          {msg && <div className="error-message">{msg}</div>}
        </form>
        
        <button 
          className="forgot-password-button"
          onClick={() => setShowForgot(!showForgot)}
        >
          Forgot password?
        </button>
        
        {showForgot && (
          <div className="forgot-password-form">
            <form onSubmit={handleForgotPassword}>
              <div className="form-group">
                <label htmlFor="forgot-email">Email</label>
                <input
                  id="forgot-email"
                  type="email"
                  placeholder="Enter your email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                />
              </div>
              
              <button type="submit" className="reset-button">
                Send Reset Link
              </button>
              
              {forgotMsg && (
                <div className={forgotMsg.includes('Error') ? 'error-message' : 'success-message'}>
                  {forgotMsg}
                </div>
              )}
            </form>
          </div>
        )}
      </div>
    </div>
  );
}